import { useState } from 'react';

import { Box, Button, Card, CardBody, Code, Display, Text, VStack } from '@bonusly/design-system';
import { useIsBonuslyCompany } from '@bonusly/who-am-i';

import { GranolaConnectCard } from '../../../components/granola/granola-connect-card';
import { useGranolaMeetings, useGranolaStatus } from '../../../queries/granola';

export const RecommendationsPage = () => {
	const isBonuslyCompany = useIsBonuslyCompany();
	const { data: status } = useGranolaStatus();
	const { mutateAsync: fetchMeetings, isLoading: isFetchingMeetings } = useGranolaMeetings();
	const [meetingsResult, setMeetingsResult] = useState<unknown>(null);
	const [error, setError] = useState<string | null>(null);

	if (!isBonuslyCompany) {
		return null;
	}

	const isConnected = status?.status === 'connected';

	const handleFetchMeetings = async () => {
		setError(null);
		setMeetingsResult(null);
		try {
			const result = await fetchMeetings();
			setMeetingsResult(result);
		} catch (e) {
			setError(e instanceof Error ? e.message : 'Failed to fetch meetings');
		}
	};

	return (
		<VStack p={6} spacing={6} align="stretch" maxW="800px">
			<VStack spacing={1} align="flex-start">
				<Display as="h1" size="sm" fontWeight="bold" color="text.default">
					Recognition Recommends
				</Display>
				<Text fontSize="sm" color="text.softer">
					Connect a transcript source to surface recognition-worthy moments.
				</Text>
			</VStack>

			<GranolaConnectCard returnPath="/recommendations" />

			{isConnected && (
				<Card variant="outline" borderColor="border.soft" borderRadius="lg">
					<CardBody py={4} px={5}>
						<VStack spacing={4} align="stretch">
							<VStack spacing={1} align="flex-start">
								<Text fontWeight="semibold" fontSize="sm" color="text.default">
									Test: Fetch Meetings (last 30 days)
								</Text>
								<Text fontSize="xs" color="text.softer">
									Calls the Granola MCP to list your recent meetings.
								</Text>
							</VStack>

							<Button size="sm" colorScheme="primary" variant="outline" onClick={handleFetchMeetings} isLoading={isFetchingMeetings} alignSelf="flex-start">
								Fetch Meetings
							</Button>

							{error && (
								<Text fontSize="sm" color="error.fg">
									{error}
								</Text>
							)}

							{meetingsResult != null && (
								<Box bg="bg.canvas" borderRadius="md" p={4} maxH="400px" overflowY="auto">
									<Code as="pre" fontSize="xs" whiteSpace="pre-wrap" wordBreak="break-word" display="block" bg="transparent">
										{JSON.stringify(meetingsResult, null, 2)}
									</Code>
								</Box>
							)}
						</VStack>
					</CardBody>
				</Card>
			)}
		</VStack>
	);
};
